import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/KR.png'


const _hoisted_1 = { class: "flex w-3/4 max-w-lg flex-col items-center justify-center overflow-hidden rounded-2xl bg-blue-50" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo",
  class: "h-56 w-full object-cover"
}, null, -1)
const _hoisted_3 = { class: "flex flex-col justify-center pb-4 pl-6 pr-6 pt-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Felhasználónév", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Jelszó", -1)
const _hoisted_6 = { class: "flex justify-evenly" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Még nincs fiókod?", -1)

import CustomButton from "@/ui_components/customButton.vue";
import { ref } from "vue";
import useLogin from "../components/useLogin.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const email = ref("");
const password = ref("");

const handleClick = () => {
  useLogin.login({ email: email.value, password: password.value });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
        type: "email",
        class: "mb-2 rounded border-2 border-primary"
      }, null, 512), [
        [_vModelText, email.value]
      ]),
      _hoisted_5,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
        type: "password",
        class: "mb-4 rounded border-2 border-primary"
      }, null, 512), [
        [_vModelText, password.value]
      ]),
      _createVNode(CustomButton, {
        onClick: handleClick,
        variant: "filled",
        type: "submit"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Bejelentkezés ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode(CustomButton, {
        variant: "outlined",
        class: "w-32"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Regisztráció ")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})